import {
  AfterViewInit,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { CashierService } from "../../services/cashier.service";
import {
  CUSTOM_AMOUNT_ONE,
  CUSTOM_AMOUNT_THREE,
  CUSTOM_AMOUNT_TWO,
  DEFAULT_MAX_LIMIT,
  DEFAULT_MIN_LIMIT,
  USER_DEFAULT_CURRENCY_SYMBOL,
  CASHIER_TYPES,
} from "../../config/cashier.config";
import { UserDetailsService } from "../../../services/user-details.service";
import { EmitterService } from "../../../services/emitter.service";
import { Utility } from "../../../shared/utility/utility";
import * as $ from 'jquery'

@Component({
  selector: "app-custom-amount",
  templateUrl: "./custom-amount.component.html",
  styleUrls: ["./custom-amount.component.scss"],
})
export class CustomAmountComponent implements OnInit, AfterViewInit {
  amountOne = '0';
  amountTwo = '0';
  amountThree = '0';
  userCurrency = USER_DEFAULT_CURRENCY_SYMBOL;
  selectedAmount: any = "0";
  cashierAmountsConfig = [];
  width = 40;

  minLimit:any = DEFAULT_MIN_LIMIT;
  maxLimit:any = DEFAULT_MAX_LIMIT;

  isAmountValid=false;
  isCurrencyDefaultPosition= true;

  @Output() selectedAmountEmitter = new EventEmitter<any>();

  @ViewChild("inputAmount") inputAmountElement: ElementRef;
  @ViewChild('inputRef', { static: false }) inputRef: any;
  constructor(
    private cashierService: CashierService,
    private userDetailsService: UserDetailsService,
    private emitterService:EmitterService,
    private utils:Utility
  ) {
    this.updateDefaultLimits()
  }

  ngOnInit(): void {
    this.cashierAmountsConfig = this.cashierService.customCashierAmountInputs;
    this.userCurrency = this.userDetailsService.getUserCurrencySymbol();
    this.isCurrencyDefaultPosition = this.userDetailsService.userCurrencyInfo?.position == 'after' ? false : true
    if (this.cashierAmountsConfig && this.cashierAmountsConfig.length) {
      this.updateConfigAmounts();
    } else {
      this.getCustomAmount(CASHIER_TYPES.TRANSACTION_DEPOSIT, this.userDetailsService.getCurrencyCode());
    }

    this.emitterService.statusCall$.subscribe((status) =>{
      if(status == 'updated'){
        this.userCurrency = this.userDetailsService.getUserCurrencySymbol();
        this.isCurrencyDefaultPosition = this.userDetailsService.userCurrencyInfo?.position == 'after' ? false : true
        this.getCustomAmount(CASHIER_TYPES.TRANSACTION_DEPOSIT, this.userDetailsService.getCurrencyCode());
      }
    });
  }

  ngAfterViewInit(): void {
    this.onSelectAmount(this.inputRef.nativeElement, CUSTOM_AMOUNT_TWO)
    if(!this.utils.isMobile()){
     setTimeout(()=>{
      this.focusAmountInput();
     },1000)
    }
  }
  resetValue(){
    if(this.selectedAmount){
      this.selectedAmount = parseFloat(this.selectedAmount)
    }
  }

  onAmountChange(e) {
    this.checkMaxValue(e.target);
  }
  setSelectedAmountOnKeyup(event){
    if(event.keyCode == 48){
      this.selectedAmount = parseFloat(this.selectedAmount);
    }
  }
  
  getCustomAmount(type, currency) {
    this.cashierService
      .getCashierAmountConfig(type, currency)
      .subscribe((res: any) => {
        if (res && res[0] && res[0].amounts && res[0].amounts.length && res[0].amounts.length >= 3) {
            //sort amounts
            res[0].amounts = res[0].amounts.sort(function (a, b) {return a - b;});
            this.cashierAmountsConfig = res[0].amounts;
            this.cashierService.customCashierAmountInputs = this.cashierAmountsConfig;
            this.updateConfigAmounts();
            this.checkQuickDepositBannerClicked();
        } else {
            this.updateDefaultValues();
        }
      });
  }
  updateConfigAmounts() {
    this.amountOne = this.cashierAmountsConfig[0];
    this.amountTwo = this.cashierAmountsConfig[1];
    this.amountThree = this.cashierAmountsConfig[2];
    this.setSelectedAmount(this.amountTwo);
  }
  setSelectedAmount(amount){
    if(this.cashierService.isQuickDepositClicked && this.cashierService.quickDepositSelectionAmount){
      let selectedAmount = this.cashierService.quickDepositSelectionAmount;
      this.selectedAmount = selectedAmount;
    }else{
      this.selectedAmount = amount;
    }
    this.selectedAmountEmitter.emit(this.selectedAmount);
  }
  
  updateDefaultValues() {
    this.amountOne = CUSTOM_AMOUNT_ONE;
    this.amountTwo = CUSTOM_AMOUNT_TWO;
    this.amountThree = CUSTOM_AMOUNT_THREE;
    this.setSelectedAmount(this.amountTwo);
  }
  updateDefaultLimits(){
    this.minLimit = DEFAULT_MIN_LIMIT;
    this.maxLimit = DEFAULT_MAX_LIMIT;
  }
  checkQuickDepositBannerClicked(){

  }
  onSelectAmount(event,amount) {
    this.selectedAmount = amount;
    $('#inputAmount')[0].innerText = amount;
    this.checkMaxValue(event);
    this.selectedAmountEmitter.emit(this.selectedAmount);
    this.setCaretToEnd(event);
  }
  checkMaxValue(e) {
    let val: any = $('#inputAmount')[0].innerText;
    if (val && parseFloat(val)) {
      val = parseFloat(val);
      if (val > this.maxLimit) {
        this.selectedAmount = this.maxLimit;
        $('#inputAmount')[0].innerText = this.maxLimit;
        this.setCaretToEnd(e);
      }else{
        this.selectedAmount = val
      }
    }else{
      this.selectedAmount = ''
    }
    this.isAmountValid = this.isEnteredAmountValid();
    this.selectedAmountEmitter.emit(this.selectedAmount);
  }
  isEnteredAmountValid(){
    if(this.selectedAmount && this.selectedAmount >= this.minLimit && this.selectedAmount <= this.maxLimit){
      return true;
    }
    return false;
    
  }
  focusAmountInput() {
    let cInput = document.getElementById('inputAmount');
    setTimeout(()=>{
      cInput?.focus();
    },100)
  }
  currentKeyCode = '';
  onKeyDown(event){
    let keyCodes:any = [189,187];
    if(keyCodes.includes(event.keyCode) || ((event.keyCode == 190 || event.keyCode == 48) && !this.selectedAmount) || (event.keyCode === 48 && this.selectedAmount < 1 )){
      event.preventDefault();
    }
    this.currentKeyCode = event.keyCode;
  }
  setCaretToEnd(event){
    this.utils.setCaretToEnd(event);
  }

  onKeyDownCheckAmount(event){
  
    let keyCode = (event.keyCode ? event.keyCode : event.which);
    if (((
           (keyCode < 48 || keyCode > 57) 
           && keyCode !== 190
           && keyCode !=13 
           && keyCode != 8
           && keyCode != 46
          )&& !(keyCode >=96 && keyCode <= 105) 
           && keyCode != 39 
           && keyCode != 37
         ) 
         || this.selectedAmount?.includes('.') && keyCode == 190 
         || (!this.selectedAmount && (keyCode == 190 || keyCode == 48 || keyCode ==96))
        ) { 
        event.preventDefault();
    }
    // !(keyCode < 96 || keyCode > 105)
  }
}
